import type { CanvasEvent, HoverEvent } from '../CanvasEvent';
import CanvasObject from '../CanvasObject';
import type SurfaceBase from '../SurfaceBase';
import type { LngLat } from '../SurfaceBase';
import VertexObject from '../VertexObject';
import { TEXT_PADDING } from './common';

export default class DrawTextObject extends CanvasObject {
  pointerVertex: VertexObject;
  onText: (p: LngLat[], description: string) => void;

  constructor(id: string, surface: SurfaceBase, onText: (p: LngLat[], description: string) => void) {
    super(id, surface);
    this.pointerVertex = new VertexObject('pointer', this.surface, {
      point: { x: NaN, y: NaN },
      lngLat: { lng: NaN, lat: NaN },
    });
    this.addChild(this.pointerVertex);
    this.onText = onText;
  }

  onSurfaceTap = (e: CanvasEvent) => {
    const lines = ['Important', 'notes', 'go here 🚩'];
    const defaultFontSize = 42;
    const ctx = this.surface.context;
    ctx.font = `bold ${defaultFontSize}px sans-serif`;
    let width = 0;
    let height = lines.length * defaultFontSize;
    for (let i = 0; i < lines.length; i++) {
      width = Math.max(width, ctx.measureText(lines[i]).width);
    }

    height += 2 * TEXT_PADDING;
    width += 2 * TEXT_PADDING;

    const screenCoords = [
      { x: e.point.x - width / 2, y: e.point.y - height / 2 },
      { x: e.point.x + width / 2, y: e.point.y - height / 2 },
      { x: e.point.x + width / 2, y: e.point.y + height / 2 },
      { x: e.point.x - width / 2, y: e.point.y + height / 2 },
    ];

    const mapCoords = screenCoords.map(this.surface.toMapCoords);

    this.onText([...mapCoords, mapCoords[0]], lines.join('\n'));
    e.stopBubble();
  };

  onPointerMove = (e: HoverEvent) => {
    this.pointerVertex.setCoords(e);
    this.surface.renderAll();
  };

  render(ctx: CanvasRenderingContext2D) {
    // there is nothing to render
  }

  drawHitArea(ctx: OffscreenCanvasRenderingContext2D, color: string): void {
    // no hit area since we're not drawing anything!
  }
}
